<template>
    <transition  name="message-controller__wrap-anim">
        <div v-if="messages.length > 0" class="message-controller">
            <a href="#" @click="removeAllMessages" class="message-controller__close">×</a>
            <p  :key="index" v-for="(message,index) in messages" class="message-controller__item" :class="cssClass[index]">
                <i v-if="type[index] == 'success'" class="glyphicon glyphicon-ok glyphicon--success"></i>
                <i v-else class="glyphicon glyphicon-exclamation-sign glyphicon--error"></i>
                {{message}}
            </p>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'messageController',
        data() {
            return {
                messages: [],
                type: [],
                cssClass: []

            }
        },
        mounted() {
            this.$eventHub.$on('openMessageController',this.open);
        },
        beforeDestroy() {
            this.$eventHub.$off('openMessageController');
        },
        methods: {
            open(type, message) {
                this.messages.push(message);
                this.type.push(type);


                switch (type) {
                    case "success" :
                        this.cssClass.push('message-controller--success');
                        break;
                    case "error" :
                        this.cssClass.push('message-controller--error');
                        break;
                }

                setTimeout( () => {
                    this.messages.shift();
                    this.type.shift();
                    this.cssClass.shift();

                } , 5000);

            },
            removeAllMessages() {
                this.messages=[];
                this.type=[];
                this.cssClass=[];
            }

        }
    }
</script>

<style lang="less" scoped>
    .message-controller {
        position: fixed;
        z-index: 1090;
        top: 20px;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        width: fit-content;
        //min-height: 90px;
        box-shadow: 0px 0px 23px 7px rgba(0,0,0,0.72);
        border: 2px solid #5a6268;
        border-radius: 10px;
        background-color: white;
        padding: 20px 30px;
        font-size: 16px;

        &__item {
            position: relative;
            margin: 10px 0;
            display: flex;
            align-items: center;
        }
        &__close {
            color: #1b1e21;
            font-size: 26px;
            position: absolute;
            right: 12px;
            top: 0px;
        }
        &--success {
            //color: #18ff0c;

        }
        &--error {
            //color: #d63b3b;
        }
        &__wrap-anim {
            &-enter-active,
            &-leave-active {

                transition: all .3s;
            }
            &-enter,
            &-leave-to {
                opacity: 0;
                transform: translateY(-400px);
            }
        }
        .glyphicon {
            font-size: 24px;
            margin-right: 9px;
            top: -2px;
        }
        .glyphicon--success {
            color: #18ff0c;
        }
        .glyphicon--error {
            color: #d63b3b;
        }

    }
</style>